var exports = {
  "Sp": "x31de4314--215224--timeLabel",
  "V8": "x31de4314--215224--relative",
  "ys": "x31de4314--215224--absolute",
};

module.exports = exports;
